async function request(url, options, init) {
  const response = await fetch(url, {
    ...init,
    headers: {
      'Authorization': `Bearer ${options.accessToken}`,
      ...(init && init.body ? { 'Content-Type': 'application/json' } : {})
    }
  })

  if (!response.ok) {
    let errors = []

    try {
      const body = await response.json()
      errors = body.errors || (body.message ? [ body.message ] : [])
    } catch (e) {
      // kein JSON-Body
    }

    const error = new Error(errors.length ? errors.join('\n') : `HTTP ${response.status}`)
    error.status = response.status
    error.errors = errors

    throw error
  }

  if (response.status === 204) {
    return null
  }

  return await response.json()
}

export default class EmailJobService {
  constructor(baseUrl) {
    this.baseUrl = baseUrl
  }

  preview(body, options) {
    return request(`${this.baseUrl}/emailJob/preview`, options, { body: JSON.stringify(body), method: 'POST' })
  }

  create(body, options) {
    return request(`${this.baseUrl}/emailJob`, options, { body: JSON.stringify(body), method: 'POST' })
  }

  getAll(limit, options) {
    return request(`${this.baseUrl}/emailJob?limit=${limit || 100}`, options)
  }

  find(id, options) {
    return request(`${this.baseUrl}/emailJob/${id}`, options)
  }

  getDeliveries(id, status, options) {
    const query = status ? `?status=${encodeURIComponent(status)}` : ''

    return request(`${this.baseUrl}/emailJob/${id}/deliveries${query}`, options)
  }

  getDeliveriesForRecipient(recipientId, options) {
    return request(`${this.baseUrl}/emailJob/deliveries?recipientId=${encodeURIComponent(recipientId)}`, options)
  }

  retryFailed(id, options) {
    return request(`${this.baseUrl}/emailJob/${id}/retry-failed`, options, { method: 'POST' })
  }

  cancel(id, options) {
    return request(`${this.baseUrl}/emailJob/${id}/cancel`, options, { method: 'POST' })
  }
}
